import React, { lazy } from 'react';
// const { Header } = lazy(() => import('./components/Header'));
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { PageBanner } from './components/PageBanner';
import { TestimonialSlider } from './components/TestimonialSlider';
import { HomeBlocks } from './components/HomeBlocks';
import { InteriorBlocks } from './components/InteriorBlocks';
import { FormDisplay } from './components/FormDisplay';
import { GoogleMapDisplay } from './components/GoogleMapDisplay';
import { PostArchive } from './components/PostArchive';
import { IframeAccordion } from './components/IframeAccordion';

export default {
  Header,
  Footer,
  PageBanner,
  HomeBlocks,
  InteriorBlocks,
  TestimonialSlider,
  FormDisplay,
  GoogleMapDisplay,
  PostArchive,
  IframeAccordion,
};
